import styled from "styled-components";

// Constants
import * as businessProfileConsts from "../../../constants/business-profile/business-profile.constants";

export const PillStyles = styled.div`
  padding: ${({ theme }) => theme.spacing[4]} ${({ theme }) => theme.spacing[8]};
  font-style: normal;
  font-weight: ${({ theme }) => theme.typography.body.b2.weight};
  font-size: ${({ theme }) => theme.typography.body.b2.size};
  line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
  text-transform: capitalize;

  ${({ $rounded, theme }) => {
    if ($rounded) {
      return `border-radius: ${theme.radius.rounded};`;
    }
  }}

  ${({ $status, theme }) => {
    if ($status === businessProfileConsts.BUSINESS_STATUS_VERIFIED) {
      return `
      background: ${theme.colors.success[400]};
      color: ${theme.colors.semantic.accent.onAccent};`;
    }
    if ($status === businessProfileConsts.BUSINESS_STATUS_PENDING) {
      return `
      background: ${theme.colors.primary[400]};
      color: ${theme.colors.semantic.accent.onAccent};`;
    }
    if ($status === businessProfileConsts.BUSINESS_STATUS_NOT_VERIFIED) {
      return `
      background: ${theme.colors.error[500]};
      color: ${theme.colors.semantic.accent.onAccent};`;
    }
  }}
`;
